import { render, staticRenderFns } from "./UnboxPrice.vue?vue&type=template&id=b2341ac6&"
import script from "./UnboxPrice.vue?vue&type=script&lang=js&"
export * from "./UnboxPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports